import { Winner } from '@flipster/apis/v1/exchange/types';
import { css } from '@flipster/styled-system/css';
import { flex, hstack } from '@flipster/styled-system/patterns';

import MarqueeItem from './MarqueeItem';

interface Props {
  winners: Array<Winner & { isSpot: boolean }>;
}

export const marqueeGroupCSS = hstack({
  flexShrink: 0,
  gap: 80,
  justify: 'space-around',
  animation: 'marqueeScrollX linear infinite',
});

const Marquee = ({ winners }: Props) => {
  return (
    <article className={css({ maxW: '100vw' })}>
      <div
        className={flex({
          gap: 80,
          overflow: 'hidden',
          userSelect: 'none',
          '&:hover > div': {
            animationPlayState: 'paused',
          },
        })}
      >
        <div className={marqueeGroupCSS} style={{ animationDuration: `${winners.length * 10}s` }}>
          {winners.map((winner, index) => (
            <MarqueeItem key={`marquee_${winner.nickname}_${index + 1}`} {...winner} />
          ))}
        </div>
        {/* infinite하게 보이기 위해 한 벌 더 만듬 */}
        <div className={marqueeGroupCSS} style={{ animationDuration: `${winners.length * 10}s` }}>
          {winners.map((winner, index) => (
            <MarqueeItem key={`marquee_dup_${winner.nickname}_${index + 1}`} {...winner} />
          ))}
        </div>
      </div>
    </article>
  );
};

export default Marquee;
